import React, { createContext, useState } from 'react';

export const RoleContext = createContext();

const RoleProvider = ({ children }) => {
  const [roles, setRoles] = useState([
    { id: 1, name: 'Admin', description: 'Administrator with all permissions' },
    { id: 2, name: 'Editor', description: 'Can edit content' },
    { id: 3, name: 'Viewer', description: 'Can view content' },
  ]);

  const simulateApiCall = (callback) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        callback();
        resolve();
      }, 1000); // Simulate a 1-second API delay
    });
  };

  const addRole = async (role) => {
    await simulateApiCall(() => {
      setRoles((prevRoles) => [...prevRoles, { id: Date.now(), ...role }]);
    });
  };

  const editRole = async (id, updatedRole) => {
    await simulateApiCall(() => {
      setRoles((prevRoles) =>
        prevRoles.map((role) => (role.id === id ? updatedRole : role))
      );
    });
  };

  const deleteRole = async (id) => {
    await simulateApiCall(() => {
      setRoles((prevRoles) => prevRoles.filter((role) => role.id !== id));
    });
  };

  return (
    <RoleContext.Provider value={{ roles, addRole, editRole, deleteRole }}>
      {children}
    </RoleContext.Provider>
  );
};

export default RoleProvider;
